import customDimensions from './customDimensions';

export function sendEnquiryCreatedEvent(enquiryId) {
  const dimensions = customDimensions.enquiryCreated(enquiryId);
  window.dataLayer.push(dimensions);
}

export function sendBuyerSentFirstMessageToDealerEvent() {
  const dimensions = customDimensions.buyerSentFirstMessageToDealer;
  window.dataLayer.push(dimensions);
}

export function sendMotorwayClickEvent() {
  const dimensions = customDimensions.motorwayClick;
  window.dataLayer.push(dimensions);
}

export function sendSelectMakeEvent(make) {
  const dimensions = customDimensions.selectMake(make);
  window.dataLayer.push(dimensions);
}

export function sendSelectModelEvent(model) {
  const dimensions = customDimensions.selectModel(model);
  window.dataLayer.push(dimensions);
}

export function sendInputAttemptEvent(fieldName) {
  const dimensions = customDimensions.inputAttempt(fieldName);
  window.dataLayer.push(dimensions);
}

export function sendZutoOptInResultEvent(isOptedIn, make, model) {
  const dimensions = customDimensions.zutoOptInResult(isOptedIn, make, model);
  window.dataLayer.push(dimensions);
}

export function sendOemOptInResultEvent(isOptedIn, make, model) {
  const dimensions = customDimensions.oemOptInResult(isOptedIn, make, model);
  window.dataLayer.push(dimensions);
}

export function sendOemPopupResultEvent(make) {
  const dimensions = customDimensions.campaignPopup(make);
  window.dataLayer.push(dimensions);
}

export function sendZutoPopupResultEvent() {
  const dimensions = customDimensions.zutoPopup;
  window.dataLayer.push(dimensions);
}

export function sendVitalityPopupResultEvent() {
  const dimensions = customDimensions.vitalityPopup;
  window.dataLayer.push(dimensions);
}



// WEBPACK FOOTER //
// ./src/utils/ga/events/index.js